// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"a99840e8","364":"8ef18dc7","453":"1e87dc8c"}[chunkId] + ".chunk.js";
};